'use strict';
angular.module('schoolLinqApp').directive('rcCheckbox', function () {
	return {
		require: ['ngModel'],
		scope: {
			labelName: '@',
			ngModel: '=',
			disabled: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/reports/rcCheckbox.html'),
	};
});
